import React, { Component } from "react";
import Axios from "axios";
import AxiosConfig from "../../../../utilities/AxiosConfig";
import {
  Table,
  InputGroup,
  Form,
  Col,
  Row,
  Spinner,
  Tooltip,
  OverlayTrigger,
} from "react-bootstrap";

import "./JobTitleMaintenance.css";
import JobTitleModal from "./JobTitleModal";
import JobTitleConfirmModal from "./JobTitleConfirmModal";
import snackBar from "src/utilities/snackBar/SnackBar";

export interface JobTitleObject {
  JobTitleID?: number;
  JobTitle: string;
}

interface MyState {
  jobTitles: JobTitleObject[];
  currentTargetValue: string;
  editItemStatus: boolean;
  targetItemId: number;
  editItemOrig: string;
  searchValue: string;
  searchValueStatus: boolean;
  showEditModal: boolean;
  showConfirmModal: boolean;
  loadingStatus: boolean;
  activeJobTitleByUserCount: number;
}

class JobTitleMaintenance extends Component<{}, MyState> {
  constructor(props: any) {
    super(props);
    this.state = {
      jobTitles: [],
      currentTargetValue: "",
      editItemStatus: false,
      targetItemId: -1,
      editItemOrig: "",
      searchValue: "",
      searchValueStatus: false,
      showEditModal: false,
      showConfirmModal: false,
      loadingStatus: true,
      activeJobTitleByUserCount: 0,
    };
  }

  componentDidMount() {
    this.updateTableData();
  }

  updateTableData = () => {
    Axios.get(
      `${process.env.REACT_APP_API_URL}/api/company/jobtitles`,
      AxiosConfig.configValue("min")
    )
      .then((response) => {
        const tableData = this.sortJobTitlesAlphabetically(response.data);
        this.setState({
          jobTitles: tableData,
          currentTargetValue: "",
          targetItemId: -1,
          editItemOrig: "",
          editItemStatus: false,
          showEditModal: false,
          showConfirmModal: false,
          loadingStatus: false,
        });
        return;
      })
      .catch((error) => {
        this.showErrorPopup(error.response.data);
      });
  };

  sortJobTitlesAlphabetically = (array: any) => {
    const sorted = [...array].sort((a: any, b: any) =>
      b.JobTitle > a.JobTitle ? -1 : 1
    );
    return sorted;
  };

  cancelEditingTitle = () => {
    this.setState({
      editItemStatus: false,
      targetItemId: -1,
      editItemOrig: "",
      currentTargetValue: "",
      showEditModal: false,
    });
  };

  onChangeValue = (event: any) => {
    this.setState({ currentTargetValue: event.target.value });
  };

  showAddTitleModal = () => {
    this.setState(() => {
      return {
        editItemStatus: false,
        showEditModal: true,
      };
    });
  };

  postNewJobTitle = (event: any) => {
    event.preventDefault();

    this.setState({
      loadingStatus: true,
    });

    const data: JobTitleObject = {
      JobTitle: this.state.currentTargetValue,
    };

    Axios.post(
      `${process.env.REACT_APP_API_URL}/api/company/jobtitles`,
      data,
      AxiosConfig.configValue("min")
    )
      .then((response: any) => {
        if (response.status === 200) {
          this.updateTableData();
          this.showSuccessPopup(`Successfuly added: ${data.JobTitle}.`);
        }
      })
      .catch((error: any) => {
        this.showErrorPopup(error.response.data);
      });
  };

  showEditTitleModal = (item: any) => {
    this.setState(() => {
      return {
        editItemStatus: true,
        currentTargetValue: item.JobTitle,
        targetItemId: item.JobTitleID,
        editItemOrig: item.JobTitle,
        showEditModal: true,
      };
    });
  };

  editExistingJobTitle = (event: any) => {
    event.preventDefault();

    this.setState({
      loadingStatus: true,
    });

    const data: JobTitleObject = {
      JobTitleID: this.state.targetItemId,
      JobTitle: this.state.currentTargetValue,
    };

    Axios.patch(
      `${process.env.REACT_APP_API_URL}/api/company/jobtitles`,
      data,
      AxiosConfig.configValue("min")
    )
      .then((response: any) => {
        if (response.status === 200) {
          this.updateTableData();
          this.showSuccessPopup(`Successfuly updated: ${data.JobTitle}.`);
        }
      })
      .catch((error: any) => {
        this.showErrorPopup(error.response.data);
      });
  };

  showConfirmDeleteTitleModal = (item: any) => {
    this.checkJobTitleCurrentUsage(item);
  };

  deleteExistingJobTitle = () => {
    this.setState({
      loadingStatus: true,
    });

    const data: JobTitleObject = {
      JobTitleID: this.state.targetItemId,
      JobTitle: this.state.currentTargetValue,
    };

    Axios.delete(
      `${process.env.REACT_APP_API_URL}/api/company/jobtitles?JobTitleId=${data.JobTitleID}`,
      AxiosConfig.configValue("min")
    )
      .then((response: any) => {
        if (response.status === 200) {
          this.updateTableData();
          this.showSuccessPopup(`Successfuly deleted: ${data.JobTitle}.`);
        }
      })
      .catch((error: any) => {
        this.showErrorPopup(error.response.data);
      });
  };

  checkJobTitleCurrentUsage = (item: any) => {
    const data: JobTitleObject = {
      JobTitle: item.JobTitle,
      JobTitleID: item.JobTitleID,
    };

    Axios.post(
      `${process.env.REACT_APP_API_URL}/api/company/jobtitles/usage`,
      data,
      AxiosConfig.configValue("min")
    )
      .then((response) => {
        this.setState({
          activeJobTitleByUserCount: response.data,
          showConfirmModal: true,
          currentTargetValue: item.JobTitle,
          targetItemId: item.JobTitleID,
        });
      })
      .catch((error) => {
        this.showErrorPopup(error.response.message);
      });
  };

  cancelDeletingTitle = () => {
    this.setState({
      showConfirmModal: false,
    });
  };

  showSuccessPopup = (message: string, title?: string) => {
    snackBar({
      text: message,
      type: "success",
      timeout: 15000,
    });
  };

  showErrorPopup = (message: string, title?: string) => {
    this.cancelEditingTitle();
    this.cancelDeletingTitle();

    snackBar({
      text: message,
      type: "error",
      timeout: 30000,
    });

    this.setState({
      loadingStatus: false,
    });
  };

  filterJobTitlesBySearch = (event: any) => {
    event.preventDefault();

    if (event.target.value.length > 0) {
      this.setState({
        searchValueStatus: true,
        searchValue: event.target.value,
      });
    } else {
      this.setState({
        searchValueStatus: false,
        searchValue: event.target.value,
      });
    }
  };

  render() {
    return (
      <div style={{ width: "100%" }}>
        {/* Page Header */}
        <div style={{ margin: "25px" }}>
          <h3 style={{ fontWeight: "bold" }}>Job Title Maintenance</h3>
        </div>
        <div className="job-title-maintenance-page">
          {/* Table Controls */}
          <div className="job-title-tools">
            <Form>
              <Row>
                <Col>
                  <InputGroup className="job-title-search-bar">
                    <InputGroup.Text id="searchBar" className="material-icons">
                      search
                    </InputGroup.Text>
                    <Form.Control
                      type="text"
                      placeholder="Search"
                      value={this.state.searchValue}
                      onChange={this.filterJobTitlesBySearch}
                    />
                  </InputGroup>
                </Col>
                <Col style={{ justifyContent: "flex-end", display: "flex" }}>
                  <OverlayTrigger
                    trigger={["hover", "focus"]}
                    placement="left"
                    overlay={
                      <Tooltip id={`tooltip-left`}>Add Job Title.</Tooltip>
                    }
                  >
                    <span
                      className="material-icons"
                      style={{
                        color: "#28a745",
                        fontSize: "30px",
                        userSelect: "none",
                        cursor: "pointer",
                      }}
                      onClick={() => this.showAddTitleModal()}
                    >
                      add
                    </span>
                  </OverlayTrigger>
                </Col>
              </Row>
            </Form>
          </div>
          {/* Start of Table */}
          <div>
            <Table striped bordered={true} hover size="md">
              <thead>
                <tr>
                  <th>Job Title</th>
                </tr>
              </thead>
              {!this.state.loadingStatus ? (
                <tbody
                  style={{
                    textAlign: "left",
                    height: "57vh",
                    overflowX: "hidden",
                    overflowY: "scroll",
                    display: "block",
                  }}
                >
                  {!this.state.searchValueStatus
                    ? // {/* Without Search */}
                      this.state.jobTitles.map((item, index) => {
                        return (
                          <tr key={item.JobTitleID}>
                            <td className="table-row">
                              {item.JobTitle}
                              <span
                                style={{
                                  fontSize: "24px",
                                  float: "right",
                                  marginLeft: "5px",
                                  marginRight: "5px",
                                  cursor: "pointer",
                                }}
                                className="far edit-icon material-icons"
                                onClick={() =>
                                  this.showConfirmDeleteTitleModal(item)
                                }
                              >
                                delete
                              </span>
                              <span
                                style={{
                                  fontSize: "24px",
                                  float: "right",
                                  marginLeft: "5px",
                                  marginRight: "5px",
                                  cursor: "pointer",
                                }}
                                className="far edit-icon material-icons"
                                onClick={() => this.showEditTitleModal(item)}
                              >
                                edit
                              </span>
                            </td>
                          </tr>
                        );
                      })
                    : // {/* With Search */}
                      this.state.jobTitles
                        .filter((jobTitles) =>
                          jobTitles.JobTitle.toLowerCase().includes(
                            this.state.searchValue.toLowerCase()
                          )
                        )
                        .map((item, index) => {
                          return (
                            <tr key={item.JobTitleID}>
                              <td className="table-row">
                                {item.JobTitle}
                                <span
                                  style={{
                                    fontSize: "24px",
                                    float: "right",
                                    marginLeft: "5px",
                                    marginRight: "5px",
                                    cursor: "pointer",
                                  }}
                                  className="far edit-icon material-icons"
                                  onClick={() =>
                                    this.showConfirmDeleteTitleModal(item)
                                  }
                                >
                                  delete
                                </span>
                                <span
                                  style={{
                                    fontSize: "24px",
                                    float: "right",
                                    marginLeft: "5px",
                                    marginRight: "5px",
                                    cursor: "pointer",
                                  }}
                                  className="far edit-icon material-icons"
                                  onClick={() => this.showEditTitleModal(item)}
                                >
                                  edit
                                </span>
                              </td>
                            </tr>
                          );
                        })}
                </tbody>
              ) : (
                <tbody
                  style={{
                    height: "57vh",
                    overflowX: "hidden",
                    overflowY: "scroll",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <Spinner animation="border" role="status"></Spinner>
                </tbody>
              )}
            </Table>
          </div>
          {/* Alerts */}
          <div id="snackbar">snacks</div>
          {/* Enter/Edit Title Modal */}
          <JobTitleModal
            showModal={this.state.showEditModal}
            title={
              !this.state.editItemStatus ? "Add Job Title" : "Edit Job Title"
            }
            label={
              !this.state.editItemStatus ? "New job title..." : "Change to..."
            }
            actionButton={!this.state.editItemStatus ? "Add" : "Update"}
            onClose={this.cancelEditingTitle}
            onSave={
              !this.state.editItemStatus
                ? this.postNewJobTitle
                : this.editExistingJobTitle
            }
            startingValue={
              !this.state.editItemStatus ? "" : this.state.currentTargetValue
            }
            updateValue={this.onChangeValue}
            loadingStatus={this.state.loadingStatus}
          />
          {/* Confirm Delete Modal */}
          <JobTitleConfirmModal
            showModal={this.state.showConfirmModal}
            title={"Delete Job Title?"}
            label={`${this.state.currentTargetValue} is currently used by ${this.state.activeJobTitleByUserCount} Employees. Deleting this Job Title will permanently remove it.`}
            actionButton={"Yes, Delete Job Title"}
            onAction={this.deleteExistingJobTitle}
            onClose={this.cancelDeletingTitle}
            loadingStatus={this.state.loadingStatus}
          />
        </div>
      </div>
    );
  }
}

export default JobTitleMaintenance;
